import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'

import EmptyProductSceneCard from './ShopifyScenesDashboard/EmptyProductSceneCard'
import ProductSceneCard from './ShopifyScenesDashboard/ProductSceneCard'
import * as scenes from 'templates/outSide/scenes'
import { getTemplateInfo } from 'templates/templates'
import { delSlide } from 'controllers/logic'

const Wrapper = styled.div`
  _height: 30em;
  _width: 30em;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: scroll;
`

class ShopifyScenesDashboard extends Component {

  createNewScene = () => {
    const { app, startProductsSlideWizard } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    // console.log('app.slidesCnt', app.slidesCnt, 'templateInfo.maxSlides', templateInfo.maxSlides)
    if (app.slidesCnt < templateInfo.maxSlides) {
      // console.log('dispatch add slide')
      startProductsSlideWizard()
      // dispatch(addSlide(app))
    }
  }

  deleteSlide = (slideNum) => {
    const { app, dispatch, field, handleSceneChange } = this.props
    if (app.slidesCnt > 0 && slideNum < app.slidesCnt) {
      const activeSlideNum = _.get(field, 'location.showcaseNum')
      if (slideNum <= activeSlideNum) {
        const prevSlideNum = slideNum > 0 ? slideNum - 1 : 0
        handleSceneChange({ scene: scenes.SHOWCASE, showcaseNum: prevSlideNum, shareButtonsVisible: 0, productShown: null })
      }
      dispatch(delSlide(app, slideNum))
    }
  }

  onProductCardClick = (sh, i) => {
    return () => {
      const { handleSceneChange } = this.props
      handleSceneChange({ scene: scenes.SHOWCASE, showcaseNum: i, shareButtonsVisible: 0, productShown: null })
    }
  }

  renderRealScenesPreview () {
    const { customizedSettings, field, startProductsSlideWizard } = this.props
    return (
      _.map(customizedSettings.showcases, (sh, i) => {
        const active = _.get(field, 'location.showcaseNum') === i
        return (
          <ProductSceneCard
            key={i}
            onClick={this.onProductCardClick(sh, i)}
            showcase={sh}
            idx={i}
            customizedSettings={customizedSettings}
            active={active}
            deleteScene={this.deleteSlide}
            startProductsSlideWizard={startProductsSlideWizard}
          />
        )
      })
    )
  }

  renderEmptyScenePreview () {
    const { app } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    // console.log('app.slidesCnt', app.slidesCnt, 'templateInfo.maxSlides', templateInfo.maxSlides)
    if (app.slidesCnt < templateInfo.maxSlides) {
      return (
        <EmptyProductSceneCard
          onClick={this.createNewScene}
          noScenesYet={app.slidesCnt === 0}
        />
      )
    }
  }

  render () {
    return (
      <Wrapper>
        {this.renderRealScenesPreview()}
        {this.renderEmptyScenePreview()}
      </Wrapper>
    )
  }
}


ShopifyScenesDashboard.propTypes = {
  field: PropTypes.object.isRequired,
  customizedSettings: PropTypes.object.isRequired,
  handleSceneChange: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  startProductsSlideWizard: PropTypes.func.isRequired
}

export default connect()(ShopifyScenesDashboard)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/ShopifyScenesDashboard.js